import { valid, } from 'const/usernames'
import A from 'const/actionTypes'
import actions from '.'
import firebase from 'firebase'
import firebaseService from 'infrastructure/FirebaseService'
import N from 'const/namespace'

const syncGamerCallback = (dispatch, gamerData) => {
  firebaseService.add(
    'gamers/',
    {
      email: gamerData.email,
      initialProvider: gamerData.initialProviderId,
      name: gamerData.displayName,
      photoURL: gamerData.photoURL,
      providerData: gamerData.providerData, //TODO refactor to providerIds
      username: gamerData.username,
    },
    N.GAMERS,
    gamerData.gamerId
  )
  if (gamerData.username) {
    dispatch(actions.syncUsername(gamerData.username, gamerData.gamerId))
  }
  dispatch(actions.createCurrentGamerProfile(gamerData.gamerId))
  dispatch(actions.createCurrentGamerPurchaseProfile(gamerData.gamerId))
  dispatch(actions.alertGamer({ message: 'Account Created.', }))
}

export default {
  alertGamer: (snackbar) => {
    return (dispatch, getState) => {
      dispatch(actions.showSnackbar({
        active: true,
        message: snackbar.message,
        timeout: 4000,
      }))
    }
  },
  alertGamerWithError: (error) => {
    return (dispatch, getState) => {
      dispatch({
        type: A.DISPLAY_ERROR,
        error: error.message.toString(),
      })
      dispatch(actions.alertGamer({ message: 'Please Try Again.', }))
    }
  },
  clearGamers: () => {
    return (dispatch, getState) => {
      dispatch({ type: A.CLEAR_GAMERS, })
    }
  },
  deleteGamer: (gamerId) => {
    return (dispatch, getState) => {
      firebaseService.off('gamers/' + gamerId, N.GAMERS)
      dispatch({ type: A.DELETE_GAMER, gamerId, })
      dispatch(actions.deleteScores(gamerId))
      dispatch(actions.deleteCurrentGamerProfile(gamerId))
      dispatch(actions.deleteCurrentGamerPurchaseProfile(gamerId))
      dispatch({ type: A.DELETE_POWER_RANKING, gamerId })
      dispatch({ type: A.DELETE_MOBILE_POWER_RANKING, gamerId })

      firebase.auth().currentUser.delete().then(() => {
        console.log("Account Deleted! Goodbye :'(")
        dispatch(actions.signOut())
        dispatch(actions.alertGamer({ message: 'Account Deleted.', }))
      }, (error) => {
        if (error) {
          dispatch({
            type: A.DISPLAY_ERROR,
            error: error.message.toString(),
          })
        }
        dispatch(actions.alertGamer({ message: 'Please Try Again.', }))
      })
    }
  },
  resendVerificationEmail: () => {
    return (dispatch, getState) => {
      const gamerId = getState().auth.uid
      dispatch(actions.updateGamer(gamerId, { emailed: false, }))
    }
  },
  resetPassword: () => {
    return (dispatch, getState) => {
      const auth = firebase.auth()
      const resetEmail = getState().userInterface.resetEmail

      auth.sendPasswordResetEmail(resetEmail).then(() => {
        dispatch(actions.alertGamer({ message: 'Password Reset.', }))
      }, (error) => {
        if (error) {
          dispatch({
            type: A.DISPLAY_ERROR,
            error: error.message.toString(),
          })
        }
      })
    }
  },
  setGamer: (gamerId, gamer) => {
    return (dispatch, getState) => {
      let gamers = getState().gamers || {}
      gamers[gamerId] = gamer

      dispatch({
        type: A.SET_GAMER,
        gamers
      })
    }
  },
  syncGamer: (authData) => {
    return (dispatch, getState) => {
      const providerData = authData.providerData
      const initialProvider = providerData && providerData[0]
      const initialProviderId = initialProvider && initialProvider.providerId
      const providedUsername = getState().userInterface.username
      const displayName = authData.displayName
      const email = authData.email

      let gamerData = {
        email: email,
        gamerId: authData.uid,
        initialProviderId: initialProviderId,
        name: displayName,
        photoURL: authData.photoURL,
        providerData: providerData,
      }

      if (providedUsername) {
        return valid(providedUsername).then(validatedUsername => {
          if (validatedUsername) {
            gamerData.username = providedUsername
            return syncGamerCallback(dispatch, gamerData)
          } else if (displayName) {
            return valid(displayName).then(validatedDisplayName => {
              if (validatedDisplayName) {
                gamerData.username = displayName
                return syncGamerCallback(dispatch, gamerData)
              }

              return valid(email.split('@')[0]).then(validatedEmail => {
                if (validatedEmail) {
                  gamerData.username = email.split('@')[0]
                }
                return syncGamerCallback(dispatch, gamerData)
              })
            })
          }
          return valid(email.split('@')[0]).then(validatedEmail => {
            if (validatedEmail) {
              gamerData.username = email.split('@')[0]
            }
            return syncGamerCallback(dispatch, gamerData)
          })

        })
      }
      if (displayName) {
        return valid(displayName).then(validatedDisplayName => {
          if (validatedDisplayName) {
            gamerData.username = displayName
            return syncGamerCallback(dispatch, gamerData)
          }
          return valid(email.split('@')[0]).then(validatedEmail => {
            if (validatedEmail) {
              gamerData.username = email.split('@')[0]
            }
            return syncGamerCallback(dispatch, gamerData)
          })
        })
      }
      return valid(email.split('@')[0]).then(validatedEmail => {
        if (validatedEmail) {
          gamerData.username = email.split('@')[0]
        }
        return syncGamerCallback(dispatch, gamerData)
      })

    }
  },
  syncUsername: (username, uid) => {
    return (dispatch, getState) => {
      if (username && uid) {
        firebaseService.add(
          'usernames/',
          {
            gamerId: uid,
          },
          N.GAMERS,
          username
        )
        window.heap.addUserProperties({ username: username })
      }
    }
  },
  updateEmail: () => {
    return (dispatch, getState) => {
      const gamer = firebase.auth().currentUser
      const newEmail = getState().userInterface.newEmail

      gamer.updateEmail(newEmail).then(() => {
        gamer.sendEmailVerification().then(() => {
          dispatch({
            type: A.CHANGE_EMAIL,
            email: newEmail,
          })
          dispatch(actions.updateGamer(
            gamer.uid,
            {
              email: newEmail,
              emailed: true,
              verified: false,
            }
          ))
          window.heap.addUserProperties({ email: newEmail })
          dispatch(actions.alertGamer({ message: 'Email Changed.', }))
        }, (error) => {
          if (error) {
            if (error) { dispatch(actions.alertGamerWithError(error)) }
          }
        })
      }, (error) => {
        if (error) { dispatch(actions.alertGamerWithError(error)) }
      })
    }
  },
  updateFacebook: () => {
    return (dispatch, getState) => {
      const gamer = firebase.auth().currentUser
      dispatch(actions.updateGamer(
        gamer.uid,
        {
          facebook: true,
        }
      ))
    }
  },
  updateGamer: (gamerId, gamerData) => {
    return (dispatch, getState) => {
      if (gamerId) {
        let gamer = getState().gamers[gamerId] || {}
        let updatedGamer = Object.assign({}, gamer, gamerData)

        dispatch({
          type: A.UPDATE_GAMER,
          gamerId,
          updatedGamer,
        })
        dispatch(actions.setCurrentGamer(updatedGamer))

        firebaseService.update(
          'gamers/' + gamerId,
          updatedGamer,
          (error) => {
            if (error) { dispatch(actions.alertGamerWithError(error)) }
          },
          N.GAMERS,
        )
      }
    }
  },
  updateGamerUsername: (uid, newUsername, oldUsername) => {
    return (dispatch, getState) => {
      dispatch(actions.updateGamer(uid, { username: newUsername }))
      dispatch(actions.syncUsername(newUsername, uid))
    }
  },
  updatePassword: () => {
    return (dispatch, getState) => {
      const gamer = firebase.auth().currentUser
      const userInterface = getState().userInterface

      gamer.updatePassword(userInterface.newPassword).then(() => {
        dispatch(actions.alertGamer({ message: 'Password Updated.', }))
      }, (error) => {
        if (error) { dispatch(actions.alertGamerWithError(error)) }
      })
    }
  },
  verifyAccount: (gamerId) => {
    return (dispatch, getState) => {
      dispatch(actions.updateGamer(gamerId, { verified: true, }))
      dispatch(actions.alertGamer({ message: 'Email Verified.', }))
    }
  },
}



// WEBPACK FOOTER //
// ./src/app/actions/gamers.js